import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const styles = () => ({
  root: {},
  rootFullWidth: {
    width: '100%',
  },
});

/**
 * @deprecated Use MetaLayoutRemainingFields instead. This component doesn't play especially nicely with the new design system components.
 */
const RemainingFieldList = ({
  className,
  classes,
  fullWidth,
  MetaControlFieldProps,
}) => {
  const { remainingFields, metaOverrideSet, resource } = useMetaLayoutContext();
  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootFullWidth]: fullWidth,
      })}
    >
      {resource.meta().template().getListOrderedByOrdinal(metaOverrideSet)
        .filter((field) => {
          return remainingFields.has(field.attr('name'));
        })
        .map((field) => {
          return (
            <MetaField
              notInLayout
              key={field.id()}
              attr={field.attr('name')}
              {...MetaControlFieldProps}
            />
          );
        })}
    </Box>
  );
};

RemainingFieldList.defaultProps = {
  className: '',
  fullWidth: true,
  MetaControlFieldProps: {},
};

RemainingFieldList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool,
  MetaControlFieldProps: PropTypes.object,
};

export default withStyles(styles)(RemainingFieldList);
